import React, { Component } from "react";
import { ReCaptcha } from "react-recaptcha-google";
import APPCONFIG from "constants/Config";
import { connect } from "react-redux";
import * as authActions from "stores/actions/auth";
import { Typography, Box, CircularProgress } from '@mui/material';

class ReCaptchaComponent extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      token: "",
      isRecaptchaLoaded: false
    };
  }

  componentDidMount() {
    // Check if grecaptcha is already loaded
    if (window.grecaptcha && window.grecaptcha.render) {
      this.setState({ isRecaptchaLoaded: true });
    } else {
      // If not, wait for it to load
      this.waitForRecaptcha();
    }
  }

  waitForRecaptcha = (attempt = 0) => {
    const maxAttempts = 10;
    if (window.grecaptcha && window.grecaptcha.render) {
      this.setState({ isRecaptchaLoaded: true });
    } else if (attempt < maxAttempts) {
      setTimeout(() => this.waitForRecaptcha(attempt + 1), 500);
    } else {
      console.error("reCAPTCHA failed to load after multiple attempts");
    }
  };

  onLoadRecaptcha = () => {
    this.setState({ isRecaptchaLoaded: true });
    if (this.captchaDemo) {
      this.captchaDemo.reset();
    }
  };

  componentWillReceiveProps(nextProps) {
    if (!nextProps.recaptcha && nextProps.recaptcha !== this.props.recaptcha) {
      this.captchaDemo && this.captchaDemo.reset();
    }
  }

  verifyCallback = (recaptchaToken) => {
    this.setState({ token: recaptchaToken });
    this.props.dispatch(authActions.recaptcha(recaptchaToken));
  };

  render() {
    const { isRecaptchaLoaded } = this.state;
    const grecaptchaObject = window.grecaptcha;

    // Check if the environment is 'development'
    const isDevEnvironment = process.env.DISABLE_RECAPTCHA === "true";

    // Don't render until grecaptcha is loaded
    if (!isDevEnvironment && !isRecaptchaLoaded) {
      return (
        <Box 
          display="flex" 
          justifyContent="center" 
          alignItems="center"
          height={78}
          border={1}
          borderColor="grey.300"
          borderRadius={1}
          bgcolor="grey.50"
          gap={1}
        >
          <CircularProgress size={16} />
          <Typography variant="body2" color="text.secondary">
            Loading reCAPTCHA...
          </Typography>
        </Box>
      );
    }

    // Conditionally render ReCaptcha component
    const captchaComponent = isDevEnvironment ? null : (
      <ReCaptcha
        ref={(el) => {
          this.captchaDemo = el;
        }}
        size="normal"
        render="explicit"
        sitekey={APPCONFIG.recaptcha.site_key}
        grecaptcha={grecaptchaObject}
        onloadCallback={this.onLoadRecaptcha}
        verifyCallback={this.verifyCallback}
      />
    );

    return <div>{captchaComponent}</div>;
  }
}

const mapStateToProps = (state) => {
  return {
    recaptcha: state.auth.recaptcha
  };
};

export default connect(mapStateToProps)(ReCaptchaComponent);